import React from 'react';
import { connect } from 'react-redux';
import { createPolling } from 'redux-polling-thunk';
import classNames from 'classnames';
import DrawComponent from './DrawComponent';
import { container } from '@Container';
import { TYPES } from '@Types';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { MyDrawAction } from '@Redux/actions';
import { drawRoundPresenter } from '@Selectors/tool/pairing/show/drawRoundPresenter';
import { FormattedMessage } from 'react-intl';
import pollingSlice from '@Redux/reducers/polling.slice';
import { defaultMessages } from '@I18n/default';

const DrawRound: React.FC<DrawRoundProps> = ({
                                               draw,
                                               loadDraw
                                             }) => {
  React.useEffect(() => {
    loadDraw(draw.myTeamId);
  }, []);

  return (
    <div className="draw-step mt-2">
      <h2
        className={classNames('text-center catcher', { 'hidden': draw.action.myArmy || draw.action.myResponse || draw.action.mySelection })}>
        <FormattedMessage {...defaultMessages.toolPairingDrawRoundSelectWaiting} /></h2>
      {draw.action.myArmy && (
        <h2 className={'text-center catcher'}>
          <FormattedMessage {...defaultMessages.toolPairingDrawRoundSelectDraw} />
        </h2>)}
      {draw.action.myResponse && (
        <h2 className={'text-center catcher'}>
          <FormattedMessage {...defaultMessages.toolPairingDrawRoundSelectResponse} />
        </h2>)}
      {draw.action.mySelection && (
        <h2 className={'text-center catcher'}>
          <FormattedMessage {...defaultMessages.toolPairingDrawRoundSelectSelect} />
        </h2>)}
      <div className="row justify-content-md-center">
        <DrawComponent displayDraw={draw.displayMyDraw} displayResponse={draw.displayResponse} draw={draw.myDraw}
                       my={true}
                       selectable={true}
                       displaySelected={true} />
        <DrawComponent displayDraw={draw.displayDraw} displayResponse={draw.displayMyResponse} draw={draw.opponentDraw}
                       my={false}
                       selectable={false} displaySelected={false} />
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    draw: drawRoundPresenter(state)
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  const drawAction = container.get<MyDrawAction>(TYPES.Actions.Tool.MyDrawAction);
  return {
    loadDraw: (myTeamId: string) => {
      dispatch(drawAction.loadDrawRequest(myTeamId));
      dispatch(
        createPolling('opponent-team-draw-check', {
          getPollingRegistration: (state, name) => state.polling.entity?.includes(name) ?? false,
          registerPolling: name => pollingSlice.actions.register(name),// dispatch an action to register the polling
          unregisterPolling: name => pollingSlice.actions.unregister(name),// dispatch an action to unregister the polling,
          fetchFunction: () => drawAction.loadDrawRequest(myTeamId),
          shouldStartCondition: () => true,
          shouldContinueCondition: (result) => true,
          onError: (error) => console.log('error', error),
          onFinish: () => console.log('finish'),
          timeout: 10000
        })
      );
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawRound);

type DrawRoundProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
